var _style, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoro02(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 777.4 178.7",
    style: {
      enableBackground: "new 0 0 777.4 178.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#88AFDD;}\n\t.st1{fill:#171515;}\n\t.st2{fill:#fff;}\n\t.st3{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st4{fill:#FFFFFF;stroke:#000000;stroke-width:0.7963;stroke-miterlimit:10;}\n\t.st5{fill:#FFFFFF;stroke:#000000;stroke-width:0.6468;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M168.5,36.1c-4.9-6.3-10.6-11.5-16.8-15.5c-7.1-4.7-15.9-8.5-26-11.3c-10.1-2.8-25.1-4.2-44.4-4.2H4.2v5.7l2,0 c4.5,0.1,7.5,0.9,8.2,2.4C15,14.4,16,17.8,16,27.8v119.2c0,6.1-0.3,10.6-0.9,13.6c-0.5,2.6-1.3,4.5-2.3,5.4c-1,0.9-2.5,1.4-4.6,1.4 h-4v5.6h78.9c13.5,0,24.8-0.7,33.5-2.1c8.9-1.4,16.5-4,22.8-7.7c6-3.5,11.6-7.8,16.8-12.9c5.2-5.1,10-11.2,14.3-18.2 c4.3-7,7.7-14.6,10.1-22.5c2.4-8,3.6-16.4,3.6-25.2c0-9.3-1.4-18.1-4.2-26.3C177.3,49.7,173.4,42.4,168.5,36.1z M41.8,153.1 c-2-3.8-2.9-9-2.9-15.5V12.7H62c18,0,33.6,2.3,46.4,6.8c9.8,3.3,18.3,7.9,25.3,13.5c7,5.6,12.6,11.8,16.7,18.2 c4.1,6.5,7.1,13.2,9,20c1.9,6.8,2.9,13.6,2.9,20.3c0,10-2.1,20.1-6.2,30.2c-4.1,10-9.5,18.3-16.2,24.6c-4.5,4.3-9.6,7.8-15,10.4 c-5.5,2.6-11.9,4.6-19,5.9c-7.1,1.3-15.5,2-24.8,2c-12.2,0-21.6-1-27.7-3.1C47.6,159.5,43.7,156.7,41.8,153.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.2,2.8c-4.3,0-7.9,1.4-10.6,4.3c-2.6,2.8-4,6.1-4,9.8c0,3.8,1.5,7,4.4,9.6c2.8,2.5,6.1,3.8,9.6,3.8 c0.3,0,0.7,0,3-0.5c1.4-0.3,1.7-0.4,1.8-0.4c0,0,0,0,0,0c0,0,0.4,0.4,0.4,2.3c0,4.2-1.3,9.3-3.8,15.1c-2.5,5.7-7.5,11.3-14.9,16.7 l-1.7,1.2l2.9,3.9l1.5-0.8c5.1-2.8,9.7-5.6,13.6-8.5c4.1-2.9,7.9-7.2,11.3-12.5c3.5-5.5,5.3-12.1,5.3-19.7c0-7.4-1.8-13.4-5.5-17.7 C216.1,5,211.5,2.8,206.2,2.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M589.5,157.5c-1.2,0.6-2.6,1.3-4.1,2.1c-1.4,0.8-2.6,1.4-3.7,1.8c-3,1.4-6.4,2.1-10.2,2.1 c-5.4,0-10.3-1.3-14.7-3.9c-4.5-2.7-8.2-5.6-10.8-8.6c-6.1-7-13-16-20.6-26.7c-7.6-10.7-12.1-17.3-13.5-19.8l0-0.1l-1-1.6l-10.4-16 c4.5-2.7,8.8-6,12.8-9.9c4.5-4.4,8.2-9.6,10.9-15.3c2.7-5.8,4.1-11.9,4.1-18.2c0-9.1-2.3-16.7-6.9-22.7c-4.5-6-10.7-10.2-18.2-12.4 c-4.1-1.4-8.5-2.3-13.2-2.6c-4.6-0.3-12-0.5-22.2-0.5h-48.4v5.6l1.9,0.1c3.7,0.2,5.5,0.6,6.4,0.9c0.9,0.3,1.7,1.3,2.3,2.8 c0.7,1.8,1.1,4.9,1.1,9v130.1c0,7.8-1,10.4-1.6,11.2c-0.5,0.8-2.3,2.1-8.2,2.3l-1.9,0.1v5.5h46.3v-5.5l-1.9-0.1 c-3.7-0.2-5.5-0.6-6.3-1c-1-0.4-1.7-1.3-2.3-2.8c-0.7-1.7-1.1-4.6-1.1-8.3V94.5c16,0,22.2-0.2,24.7-0.3l15.7,24.2 c0.1,0.2,0.1,0.3,0.2,0.4v0.3l0.3,0.5c9.9,14.9,19.3,27.7,27.9,38.1c3.5,4.3,7.3,7.8,11.3,10.3c4,2.5,7.9,4.2,11.5,5.1 c3.6,0.8,7.2,1.3,10.7,1.3c4.2,0,8.5-0.4,12.7-1.1c4.2-0.8,7.6-1.6,10.1-2.6c4.5-1.8,8.9-4.4,13-7.6l1.1-0.8l-1.8-5.8L589.5,157.5z  M454,86.3V13.6h11.4c7.4,0,13.4,0.8,17.9,2.4c4.5,1.6,8.4,4.1,11.6,7.3c2.7,2.7,5,5.8,6.7,9.2c1.7,3.4,3,7,3.9,10.8 c0.9,3.8,1.3,7.3,1.3,10.4c0,7.1-1.5,13-4.5,17.6c-3,4.7-6.7,8.3-11,10.7c-2.2,1.2-5.7,2.3-10.3,3.1c-4.7,0.8-8.7,1.2-11.9,1.2H454 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M766.4,48.8c-3.7-9.1-9.2-17.2-16.3-24.1c-7.1-6.9-15.7-12.4-25.5-16.2c-9.8-3.8-20.8-5.7-32.8-5.7 c-15.1,0-28.8,2.9-40.6,8.6c-11.8,5.7-21.8,13.4-29.5,22.7c-7.7,9.3-13.7,19.7-17.6,30.8c-3.9,11.2-5.9,22.2-5.9,32.9 c0,10.2,1.9,20.1,5.5,29.3c3.7,9.3,9.1,17.7,16.2,25c7.1,7.3,15.6,13.1,25.3,17.1c9.7,4,20.6,6.1,32.3,6.1 c14.4,0,27.7-2.6,39.6-7.7c11.8-5.1,22-12.4,30.2-21.5c8.2-9.1,14.4-19.7,18.6-31.4C769.9,103,772,90.7,772,78 C772,67.7,770.2,57.9,766.4,48.8z M737.3,143.9c-6.2,5.8-13.4,10.4-21.5,13.8c-8.1,3.4-16.4,5.1-24.7,5.1c-13,0-25.5-4-37.2-11.9 c-11.7-8-21.3-18.6-28.5-31.7c-7.2-13.1-10.8-27.1-10.8-41.7c0-11.8,3.1-22.5,9.1-32c6.1-9.5,14-16.9,23.6-22.1 c9.6-5.2,19.4-7.8,29.3-7.8c8,0,16.9,1.9,26.3,5.8c9.5,3.9,18.5,9.5,26.8,16.6c8.2,7.2,15,16,20.2,26.2c5.2,10.2,7.8,21.6,7.8,34 c0,8.7-1.9,17.1-5.6,25.1C748.5,131.1,743.5,138.1,737.3,143.9z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 253.8,
    cy: 135.4,
    r: 12.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 242.4,
    cy: 111.1,
    r: 12.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 274.1,
    cy: 154.4,
    r: 12.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 298.4,
    cy: 166.5,
    r: 12.2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 388.8,
    cy: 47.8,
    r: 12.2
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 369,
    cy: 26.5,
    r: 12.2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 344,
    cy: 13.6,
    r: 12.2
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 323.4,
    cy: 169.2,
    r: 9.7
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 239.9,
    cy: 86.3,
    r: 9.7
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 398.5,
    cy: 72.2,
    r: 9.7
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 318.6,
    cy: 9.7,
    r: 9.7
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 344,
    cy: 166.5,
    r: 7.9
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 361.1,
    cy: 158.7,
    r: 7.9
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 376.8,
    cy: 146.5,
    r: 7.9
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 390.7,
    cy: 131.9,
    r: 7.9
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 398.5,
    cy: 113.4,
    r: 7.9
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 400.6,
    cy: 94.2,
    r: 7.9
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 298.4,
    cy: 12.7,
    r: 7.9
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 280.5,
    cy: 20.5,
    r: 7.9
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 264,
    cy: 30.8,
    r: 7.9
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 251.1,
    cy: 46.5,
    r: 7.9
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 243.2,
    cy: 65.5,
    r: 7.9
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoro02);
export default __webpack_public_path__ + "static/media/Doro-02.ef875ddacf55dbf1929d0fe159113145.svg";
export { ForwardRef as ReactComponent };